import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { useGetEmailSignature } from '@/src/components/profile/Signature/api/getEmailSignature';
import { RootState } from '@/src/reducers/types';

export const useUserEmailSignature = () => {
  const userId = useSelector((store: RootState) => store.loggedUser.data.id);
  const userEmailSignatureQuery = useGetEmailSignature({ userId });

  const emailSignature = useMemo(() => {
    if (!userEmailSignatureQuery.data) return null;

    return userEmailSignatureQuery.data.emailSignature;
  }, [userEmailSignatureQuery.data]);

  return emailSignature;
};
